// IMPORTANT: this is a plugin which requires jQuery for initialisation and data manipulation

import {
  Component,
  OnInit,
  ElementRef,
  Inject,
  AfterViewInit,
} from "@angular/core";
import { Title } from "@angular/platform-browser";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { UserService } from "../../services/user.service";
import swal from "sweetalert2";
import { ContactsFormService } from "../../services/contactsform.service";
import { ContactForm } from "../../models/contactform";
import { MaterialModule } from "../../app.module";
import { ReminderService } from "../../services/reminder.service";
import { RemindersService } from "../../services/reminders.service";
import { Reminder } from "../../models/reminder";
import { ContactHistoryService } from "../../services/contacthistory.service";
import { TableData } from "../../md/md-table/md-table.component";
import { Methods } from "../../shared/methods";
import {
  CompanylinkedService,
  TimeOffFormData,
} from "../../services/companylinked.service";
import { CompanyLinked } from "../../models/companylinked";
import { FormControl } from "@angular/forms";
import { webSocket, WebSocketSubject } from "rxjs/webSocket";
import { ConfigService } from "../../services/config.service";
import { DinamicData, Cell } from "../../models/dinamic-data";
import { Observable, forkJoin } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { DatePipe } from "@angular/common";
import { MatSlideToggleChange } from "@angular/material/slide-toggle";
import {
  convertDateToISODateString,
  convertISODateStringToDate,
  convertYYYYMMDDToMMDDYYYY,
  formatTime24To12,
} from "src/app/utils/date-time-utils";
import { TitleService } from "../../services/title.service";

declare const $: any;

export interface UserList {
  value: string;
  name: string;
}

@Component({
  selector: "app-listcontactform-cmp",
  templateUrl: "listcontactform.component.html",
  styleUrls: ["./listcontactform.component.css"],
  providers: [
    UserService,
    ContactsFormService,
    MaterialModule,
    CompanylinkedService,
    DatePipe,
    RemindersService,
  ],
})
export class ListcontactformComponent implements OnInit {
  public mtds: Methods = new Methods();
  public company: CompanyLinked = new CompanyLinked();
  public soExample;
  public soLineExample;
  public poExample;
  public poLineExample;
  public selectedValues: any[] = [];
  public selectedReps: any[] = [];
  public representative_id: any = null;

  toppings = new FormControl();
  reps = new FormControl();
  public toAssagn: Array<string> = [];
  public reptoAssagn: Array<any> = [];

  //name: string;
  //animal: string;
  public contactFormsAssigned: string[][] = [];
  public contactFormsUnassigned: string[][] = [];
  public contactFormsAll: string[][] = [];
  public privilegio;
  //public pagos: Array<Pago>;
  public contacts: Array<any>;
  public prueba;
  public contact: ContactForm;
  public identity;
  public token;
  public filter = 0;
  public order = 0;
  public searchString;
  public searching = false;
  public today: Date;
  public sinceDate: any = null;
  public toDate;
  public repId = "";
  public repsList: any[] = [];
  public selectedId = "";
  public comentarios = "";
  public usersSeleccionados = [];
  public arrayUsers: any[] = [];

  public assigned: string;

  public selectId = null;

  public guardando = false;
  public cargando = false;

  public action = "create";
  public fechaContacto;

  public newLead = {
    name: "",
    email: "",
    phone: "",
    location: "",
    country_id: 0,
    state_id: 0,
    city_id: 0,
    source: "",
    descripcion: "",
    isAssign: 0,
    company: "",
  };
  public sources = [
    "Website",
    "Incoming Call",
    "Cold Call",
    "Referral",
    "Zoom",
    "Walk-In",
    "MXWebsite",
  ];
  public optionsButtonSelect;
  public optionSelectMenuTrigger;
  public filtros = [];
  public filtrosnews = [];
  public campoBusqueda = "";

  public itemsPorPagina = "10";
  public paginaActual = 1;
  public totalItems = 0;
  public totalPaginas = 1;

  myWebSocket: WebSocketSubject<any> = webSocket(
    "wss://www.greenteksolutions.com/myws"
  );
  public numberNotifications;
  public notificationsData;
  public options: Array<any> = [];

  countries: any[] = [];
  states: any[] = [];
  cities: any[] = [];

  stateControl = new FormControl();
  cityControl = new FormControl();

  filteredStates: Observable<any[]>;
  filteredCities: Observable<any[]>;

  public dataHDMode: DinamicData = new DinamicData([
    "ID",
    "Rep",
    "Start Date and Time",
    "End Date and Time",
    "Website",
    "Active",
    "Actions",
  ]);

  totalHDModeRecords;

  timeOffForm: TimeOffFormData = {
    id: null,
    assignmentType: "Rep",
    assignHolidaysLeads: null,
    type: "bydate",
    startDate: null,
    hrInicio: "",
    endDate: null,
    hrFin: "",
    applyTo: "",
  };

  public dataNewsletter: DinamicData = new DinamicData([
    "check",
    "Email",
    "Date",
    "Actions",
  ]);
  public dataUnassigned: DinamicData = new DinamicData([
    "check",
    "ID",
    "Name",
    "Company",
    "Phone",
    "Email",
    //"Location",
    "Country",
    "State",
    "City",
    "Date",
    "Source",
    "Ranking",
    "Description",
    "Rep",
    "Actions",
  ]);
  public bulkNewsletterContacts: Array<number> = [];
  public removeNewsElements: Array<number> = [];
  constructor(
    public dialog: MatDialog,
    private titleService: Title,
    private _route: ActivatedRoute,
    private _router: Router,
    private _ContactFormService: ContactsFormService,
    private _remindersService: RemindersService,
    private _userService: UserService,
    private _companyLinkedService: CompanylinkedService,
    private _config: ConfigService,
    private datePipe: DatePipe,
    private titleServices: TitleService
  ) {
    this.titleService.setTitle("Contact Form");
    this.assigned = "unassigned";
    this.today = new Date();
    this.today.setDate(this.today.getDate() + 1);
    this.toDate = this.getFecha(this.today);
    this.today.setDate(this.today.getDate() - 31);
    this.sinceDate = this.getFecha(this.today);

    this.sinceDate = new Date(this.sinceDate);
    this.toDate = new Date(this.toDate);

    this.privilegio = JSON.parse(localStorage.getItem("privilegio"));
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();

    this.getRandomValues();
    this.getReps();
    //this.getNewsletterContacts();

    this._userService
      .getAllUsersType(this.token, "purchashinsalesrep")
      .subscribe(
        (response) => {
          console.log(response);
          if (response.status == "success") {
            this.repsList = response.data;
            console.log(this.repsList);
          } else {
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
  }
  getClass() {
    if (this.showDtButtons) return "tdbtn";
    return "tdbtn2";
  }
  getClassConta() {
    if (this.showDtButtons) return "with-buttons";
    return "with-buttons2";
  }
  showDtButtons: boolean = false;
  onToggleButtons(show: boolean) {
    this.showDtButtons = show;
  }
  getNewsletterContacts(e = null, newfilter = true) {
    this.searching = true;
    // this.loadingTemplates = true;
    this._ContactFormService
      .getNewsletterContactsSort(
        this.token,
        e !== null ? e.page : 1,
        e !== null ? e.perPage : 10,
        e !== null
          ? (this.campoBusqueda = e.search)
          : (this.campoBusqueda = ""),
        this.filtrosnews,
        this.filterrigh,
        this.sortStates
      )
      .subscribe(
        (r) => {
          console.log(r);
          if (r.status == "success") {
            this.paginaActual = Number(r.page_actual);
            this.itemsPorPagina = String(r.items_per_page);
            this.totalItems = Number(r.total_items_count);
            this.totalPaginas = Number(r.total_pages);

            if (newfilter) {
              this.filtrosnews = [
                null,
                {
                  key: "filter_email",
                  title: "Email",
                  value: "",
                  type: "equalto",
                  key_type: "filter_email_type",
                  type_options: [
                    { value: "nofilter", name: "No Filter" },
                    { value: "contains", name: "Contains" },
                    { value: "startswith", name: "Starts With" },
                    { value: "endswith", name: "Ends With" },
                    { value: "equalto", name: "Equal To" },
                  ],
                },
                {
                  key: "filter_date",
                  title: "Date",
                  value: "",
                  type: "startswith",
                  key_type: "filter_date_type",
                  type_options: [   { value: 'nofilter', name: 'No Filter' }, { value: 'equalto', name: 'Equal To' }, { value: 'notequalto', name: 'Not Equal To' }, { value: 'greaterthan', name: 'Greater Than' }, { value: 'lessthan', name: 'Less Than' }],
                },
                null,
              ];
            }

            this.dataNewsletter.rows = [];
            for (let element of r.data) {
              console.log(element, "dataaass");
              // this.itemsPorPagina = r.items_per_page;
              // this.paginaActual = r.page_actual;
              // this.totalItems = r.total_items_count;
              // this.totalPaginas = r.total_pages;

              // let interno_element = JSON.parse(element.data);

              let selected_value = false;

              if (this.bulkNewsletterContacts.includes(element.id.toString()))
                selected_value = true;

              let actionButtons = [
                {
                  icon: "delete_outline",
                  action: "Remove",
                  color: "danger",
                  value: element.id,
                },
              ];
              // console.log(element.createdAt);
              let fechaGTS = element.createdAt;
              console.log(fechaGTS);
              fechaGTS = fechaGTS.split(" ");
              console.log(fechaGTS);
              fechaGTS = fechaGTS[0].split("-");
              fechaGTS = fechaGTS[1] + "-" + fechaGTS[2] + "-" + fechaGTS[0];
              this.dataNewsletter.rows.push([
                new Cell(element.id, {
                  type: "checkbox",
                  selected: selected_value,
                }), // Check box
                new Cell(element.email),
                new Cell(fechaGTS),
                new Cell(actionButtons, { type: "actions" }),
                // El segundo parametro es para especificar tipo de dato, color, estilos etc...
              ]);
            }
            this.searching = false;

            // this.bulkNewsletterContacts.push(parseInt(element.id));
          }
          console.log(this.bulkNewsletterContacts, "numbers");
        },
        (error) => {
          console.log(error);
        }
      );
  }
  deleteBulkNews() {
    this.actionNews({ action: "Remove" });
  }
  borrarBulk() {
    this.actions({ action: "Remove" });
  }
  actionNews(e) {
    switch (e.action) {
      case "Remove":
        swal
          .fire({
            title: "Remove Contact",
            text:
              this.bulkNewsletterContacts.length !== 0
                ? "Are you sure to delete these Contacts?"
                : "Are you sure to delete this Contact?",
            showCancelButton: true,
            buttonsStyling: false,
            customClass: {
              confirmButton: "btn btn-success",
              cancelButton: "btn btn-default",
            },
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Continue",
          })
          .then((result) => {
            if (result.value) {
              if (this.bulkNewsletterContacts.length !== 0) {
                this.removeNewsletter(this.bulkNewsletterContacts);
              } else {
                this.removeNewsletter([e.id]);
              }
            }
          });
        break;
      default:
        break;
    }
  }
  actions(e) {
    console.log(e, "eee");
    switch (e.action) {
      case "Remove":
        swal
          .fire({
            title: "Remove Contact",
            text:
              this.bulk.length !== 0
                ? "Are you sure to delete these Contacts?"
                : "Are you sure to delete this Contact?",
            showCancelButton: true,
            buttonsStyling: false,
            customClass: {
              confirmButton: "btn btn-success",
              cancelButton: "btn btn-default",
            },
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Continue",
          })
          .then((result) => {
            if (result.value) {
              if (this.bulk.length !== 0) {
                this.borrandoBulk(this.bulk);
              } else {
                this.eliminar(e.id);
              }
            }
          });
        break;
      case "Detail":
        this.getContactForm(e.id);
        break;
      case "Block":
        this.banear(e.id);
        break;
      case "Assign to":
        this.open(e.id, this.repId);
        break;
      case "Unassign":
        this.removeRep(e.id);
        break;
      case "unblack":
        this.unblack(e.id);
        break;
      default:
        break;
    }
  }
  removeNewsletter(data) {
    const json = {
      bulk: data,
    };
    this._ContactFormService.deleteNewsBulk(this.token, json).subscribe(
      (r) => {
        this.getNewsletterContacts();
        this.bulkNewsletterContacts = [];
      },
      (error) => {
        console.log(error);
      }
    );
  }

  resetValues1() {
    this.company.typeHolidaysLeads = "";
    this.selectedValues = [];
    this.representative_id = null;
    this.selectedReps = [];
  }

  resetValues2() {
    this.selectedValues = [];
    this.selectedReps = [];
    this.representative_id = null;
  }

  getRandomValues() {
    this._companyLinkedService.getRandomValues(this.token).subscribe((r) => {
      // console.log(r);
      if (r.status === "success") {
        for (let item of r.data) {
          this.toAssagn.push(item.role);
        }
      }
    });
  }

  getReps() {
    this._companyLinkedService.getRepsValues(this.token).subscribe((r) => {
      // console.log(r);
      if (r.status === "success") {
        for (let item of r.data) {
          this.reptoAssagn.push({
            name: item.name,
            surname: item.surname,
            id: item.id,
          });
        }
        // this.reptoAssagn = r.data;
      }
    });
  }

  pipeReps(rep) {
    // console.log(rep, "rep");
    let fullname;
    this.titleFormHDMode == "Edit"
      ? (fullname = `${rep}`)
      : (fullname = `${rep.name} ${rep.surname}`);
    // return `${rep.name} ${rep.surname}`
    return fullname;
  }
  // getRepsDetails() {
  //   return this._remindersService.getUser(rep).pipe(
  //     map((response) => {
  //       if (response.status === 'success') {
  //         // Si la solicitud es exitosa, retorna el nombre y apellido concatenados
  //         return `${response.data.name} ${response.data.surname}`;
  //       } else {
  //         // En caso de error o que no haya éxito, retorna un valor predeterminado
  //         return 'Usuario no encontrado';
  //       }
  //     })
  //   );
  // }
  pipeRep(rep) {
    switch (rep) {
      case "SALESREP":
        return "SALES REP";
      case "TECHREP":
        return "TECH REP";
      case "ADMINISTRATOR":
        return "ADMINISTRATOR";
      case "CLERICALREP":
        return "CLERICAL REP";
      case "SHIPPINGREP":
        return "SHIPPING REP";
      case "PURCHASINGREP":
        return "PURCHASING REP";
      case "RECEIVINGDEPARTMENT":
        return "RECEIVING DEPARTMENT";
      case "MANIFESTDEPARTMENT":
        return "MANIFEST DEPARTMENT";
      case "MANAGER":
        return "MANAGER";
      case "DRIVER":
        return "DRIVER";
      case "TECHREP":
        return "TECH REP";
      case "WAREHOUSE SUPERVISOR":
        return "WAREHOUSE SUPERVISOR";
      default:
        return rep;
    }
  }

  getCompany() {
    let id = this.identity.sub;
    this._companyLinkedService.getCompanySetup(this.token, id).subscribe(
      (response) => {
        if (response.status == "success") {
          this.company = response.data;

          this.calculateDigits();
          this.calculateDigitsPo();

          if (this.company.typeHolidaysLeads === "Random") {
            this.selectedValues = JSON.parse(this.company.assignHolidaysLeads);
          } else if (this.company.typeHolidaysLeads === "Rep") {
            this.selectedReps = JSON.parse(this.company.assignHolidaysLeads);
            // this.representative_id = Number(this.company.assignHolidaysLeads);
          }
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }

  calculateDigits() {
    let number = this.company.soDigits;
    let number2 = this.company.soLineDigits;

    this.soExample = "";
    this.soLineExample = "";

    if (number == 0 || number == null) {
      //this.company.soDigits = '';
    } else {
      for (let i = 1; i < number; i++) {
        this.soExample = this.soExample + "0";
      }
      this.soExample = this.soExample + "1";
    }

    if (number2 == 0 || number2 == null) {
      //this.soLineDigits = '';
    } else {
      for (let j = 1; j < number2; j++) {
        this.soLineExample = this.soLineExample + "0";
      }
      this.soLineExample = this.soLineExample + "1";
    }
  }

  calculateDigitsPo() {
    let number = this.company.poDigits;
    let number2 = this.company.poLineDigits;

    this.poExample = "";
    this.poLineExample = "";

    if (number == 0 || number == null) {
      //this.company.soDigits = '';
    } else {
      for (let i = 1; i < number; i++) {
        this.poExample = this.poExample + "0";
      }
      this.poExample = this.poExample + "1";
    }

    if (number2 == 0 || number2 == null) {
      //this.soLineDigits = '';
    } else {
      for (let j = 1; j < number2; j++) {
        this.poLineExample = this.poLineExample + "0";
      }
      this.poLineExample = this.poLineExample + "1";
    }
  }

  closeConfig() {
    $("#hdModal").modal("hide");
    this.getCompany();
  }

  public bulk: Array<number> = [];

  public borrarElementos: any = [];
  public asignarElementos: any = [];

  // checkedNews(e){
  //   this.borrarElementos = [];
  //   this.bulkNewsletterContacts = e
  //   console.log(e, 'EEEEE')
  // }

  assignbulkRep() {
    $("#assignBulkModal").modal("show");
  }

  asignando = false;
  borrando = false;

  // borrarBulk() {
  //   $("#borrarBulkModal").modal("show");
  // }

  borrandoBulk(bulk) {
    this.borrando = true;

    let json = {
      bulk: bulk,
    };

    this._ContactFormService.deleteBulk(this.token, json).subscribe(
      (r) => {
        console.log(r);
        if (r.code === 400 && r.msg === "Authorization not valid") {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else if (r.code === 200) {
          this.mtds.notifySuccess("Elements have been removed successfully");
          this.cambiar(this.assigned);
          this.finborrarBulk();
        } else {
          this.mtds.notifyError(r.msg, r.code);
        }
        this.borrando = false;
      },
      (e) => {
        console.log(e);
        this.mtds.notifyError(e.statusText);
        this.borrando = false;
      }
    );
  }

  finborrarBulk() {
    $("#borrarBulkModal").modal("hide");
  }

  public saving = false;

  // HDMODE remake
  showModalHDMode() {
    this.getDataHDMode();
    $("#hdModal").modal("show");
  }
  formHDModeVisible = false;
  titleFormHDMode = "New";
  loadingFormTimeOff = false;
  loadingTableHDMode = false;

  showFormHDMode(title) {
    // this.selectedReps = [];
    // this.resetTimeOffForm();
    if (title === "Edit") {
      this.formHDModeVisible = true;
      // this.getRepsDetails()
    } else {
      this.selectedReps = [];

      this.formHDModeVisible = !this.formHDModeVisible;
    }
    this.titleFormHDMode = title;
  }

  resetTimeOffForm() {
    this.timeOffForm = {
      assignmentType: "Rep",
      assignHolidaysLeads: null,
      type: "bydate",
      startDate: null,
      hrInicio: "",
      endDate: null,
      hrFin: "",
    };
    this.selectedValues = null;
    this.selectedReps = null;
    this.representative_id = null;
    this.showFormHDMode("New");
  }
  public newreps = [];
  postTimeOff() {
    // Activar el estado de carga antes de iniciar cualquier operación asíncrona
    this.loadingFormTimeOff = true;
    console.log(this.selectedReps, "this are selected");
    // Generar una lista de observables para obtener los usuarios seleccionados
    const userObservables = this.selectedReps.map(
      (rep) => this._remindersService.getUser(rep.id) // Solo extrae el `id` de cada objeto
    );
    forkJoin(userObservables).subscribe({
      next: (responses) => {
        console.log(responses, "responses");
        // Procesar las respuestas y construir el array newreps
        responses.forEach((response) => {
          if (response.status === "success") {
            this.newreps.push({
              id: response.data.id,
              name: response.data.name,
              surname: response.data.surname,
            });
          }
        });

        console.log("newrep", this.newreps);

        // Asignar los leads según el tipo de asignación seleccionado
        this.timeOffForm.assignHolidaysLeads =
          this.timeOffForm.assignmentType === "Random"
            ? this.selectedValues
            : this.titleFormHDMode == "Edit"
            ? this.newreps
            : this.selectedReps;

        // Ajustar las fechas según el tipo de permiso (permanente o temporal)
        if (this.timeOffForm.type === "permanent") {
          delete this.timeOffForm.startDate;
          delete this.timeOffForm.hrInicio;
          delete this.timeOffForm.endDate;
          delete this.timeOffForm.hrFin;
        } else {
          this.timeOffForm.startDate = convertDateToISODateString(
            this.timeOffForm.startDate
          );
          this.timeOffForm.endDate = convertDateToISODateString(
            this.timeOffForm.endDate
          );
        }

        // Enviar la solicitud para registrar el tiempo libre
        this._companyLinkedService
          .postTimeOff(this.token, this.timeOffForm)
          .subscribe({
            next: (response) => {
              swal.fire({
                title: "Perfect!",
                text: `HD Mode will be activated from  ${convertYYYYMMDDToMMDDYYYY(
                  response.data.startDate
                )} to ${convertYYYYMMDDToMMDDYYYY(response.data.endDate)}.`,
                icon: "success",
                buttonsStyling: false,
                customClass: {
                  confirmButton: "gts-btn-primary",
                },
                timer: 6000,
                timerProgressBar: true,
              });
            },
            error: () => {
              this.showMessageError();
            },
            complete: () => {
              // Restaurar el estado de carga y resetear el formulario al completar la operación
              this.loadingFormTimeOff = false;
              this.newreps = [];
              this.resetTimeOffForm();
              this.getDataHDMode();
              this.getStatusHDMode();
            },
          });
      },
      error: () => {
        // Manejar cualquier error en las llamadas a los usuarios
        this.loadingFormTimeOff = false;
        this.showMessageError();
      },
    });
  }

  isButtonDisabled(): boolean {
    const form = this.timeOffForm;
    if (form.assignmentType === "Rep") {
      if (this.selectedReps) {
        if (form.type === "permanent") {
          return false;
        } else if (form.type === "bydate") {
          if (
            form.startDate == "" ||
            form.hrInicio == "" ||
            form.endDate == "" ||
            form.hrFin == ""
          ) {
            return true;
          } else {
            return false;
          }
        }
      }
    } else if (form.assignmentType === "Random") {
      if (this.selectedValues.length > 0) {
        if (form.type === "permanent") {
          return false;
        } else if (form.type === "bydate") {
          if (
            form.startDate == "" ||
            form.hrInicio == "" ||
            form.endDate == "" ||
            form.hrFin == ""
          ) {
            return true;
          } else {
            return false;
          }
        }
      } else {
        return true;
      }
    }

    return true;
  }

  getDataHDMode() {
    this.loadingTableHDMode = true;
    this._companyLinkedService.getHDModeData(this.token).subscribe({
      next: (response) => {
        console.log("respppp", response);
        this.setDataTableHDMode(response.data);
        this.totalHDModeRecords = response.total_items_count;
      },
      error: (error) => {
        this.showMessageError();
      },
      complete: () => {},
    });
  }

  setDataTableHDMode(data) {
    this.dataHDMode.rows = [];

    for (let element of data) {
      let startDateTime;
      let endDateTime;
      let nameSurname;

      if (element.assignmentType === "Rep" && element.extraData) {
        // nameSurname = `${element.user.name} ${element.user.surname}`;
        try {
          const extraDataArray = JSON.parse(element.extraData);
          nameSurname = extraDataArray.join(", ");
          // Transformar cada objeto en una cadena y unirlos con comas
          // const result = extraDataArray
          //   .map((obj) => `${obj.name} ${obj.surname}`)
          //   .join(", ");

          // nameSurname = result;
        } catch (error) {
          console.error("Error parsing extraData", error);
          nameSurname = "Unknown";
        }
      } else if (element.assignmentType === "Random" && element.extraData) {
        try {
          const extraDataArray = JSON.parse(element.extraData);
          nameSurname = extraDataArray.join(", ");
        } catch (error) {
          console.error("Error parsing extraData", error);
          nameSurname = "Unknown";
        }
      } else {
        nameSurname = "Unknown";
      }

      if (element.startDate == null && element.endDate == null) {
        startDateTime = "Permanent";
        endDateTime = "Permanent";
      } else {
        startDateTime =
          convertYYYYMMDDToMMDDYYYY(element.startDate) +
          " " +
          formatTime24To12(element.horaInicio);
        endDateTime =
          convertYYYYMMDDToMMDDYYYY(element.endDate) +
          " " +
          formatTime24To12(element.horaFin);
      }

      let actionButtons = [
        {
          icon: "delete",
          action: "Remove",
          color: "danger",
          value: element.id,
        },
        {
          icon: "edit",
          action: "Edit",
          color: "#000",
          value: element.id,
        },
      ];

      this.dataHDMode.rows.push([
        new Cell(element.id),
        new Cell(nameSurname),
        new Cell(startDateTime),
        new Cell(endDateTime),
        new Cell(element.applyTo),
        new Cell(element.isActive == 1 ? "Active" : "Inactive", {
          type: "action-button",
          value: { id: element.id },
          icon: "power_settings_new",
          class: element.isActive == 1 ? "btn-success" : "gts-btn-secondary ",
          typeaction: element.isActive == 1 ? "Active" : "Inactive",
        }),
        new Cell(actionButtons, { type: "actions" }),
      ]);
    }
    this.loadingTableHDMode = false;
  }

  actionsHDMode(e) {
    switch (e.action) {
      case "Remove":
        swal
          .fire({
            title: "Are you sure you want to delete this time-off record?",
            icon: "warning",
            showCancelButton: true,
            buttonsStyling: false,
            customClass: {
              cancelButton: "gts-btn-primary-outline",
              confirmButton: "gts-btn-primary",
            },
            confirmButtonText: "Yes, delete it!",
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.deleteHDMode(e.id);
            }
          });
        break;
      case "Edit":
        this.setDataToFormTimeOff(e.id);
        break;
      default:
        break;
    }
  }

  // deleteHDMode(id){
  //   this.loadingFormTimeOff = true;
  //   this._companyLinkedService.deleteTimeOff(this.token, id).subscribe(

  //     response => {
  //       this.loadingFormTimeOff = false;
  //       if (response.status === 'success') {
  //         swal.fire({
  //           title: 'This time-off record has been successfully deleted.',
  //           icon: 'success',
  //           buttonsStyling: false,
  //           customClass: {
  //             confirmButton: 'gts-btn-primary'
  //           },
  //           timer: 2000,
  //           timerProgressBar: true
  //         });
  //         this.getDataHDMode();
  //       } else {
  //         swal.fire({
  //           title: 'Error',
  //           text: 'An error occurred while deleting the time-off record.',
  //           icon: 'error',
  //           buttonsStyling: false,
  //           customClass: {
  //             confirmButton: 'gts-btn-primary'
  //           }
  //         });
  //       }
  //     },

  //     error => {
  //       console.error(error);
  //       this.loadingFormTimeOff = false;
  //       this.showMessageError();
  //     }
  //   );
  // }

  deleteHDMode(id) {
    this.loadingFormTimeOff = true;
    this._companyLinkedService.deleteTimeOff(this.token, id).subscribe({
      next: (response) => {
        if (response.status === "success") {
          swal.fire({
            title: "This time-off record has been successfully deleted.",
            icon: "success",
            buttonsStyling: false,
            customClass: {
              confirmButton: "gts-btn-primary",
            },
            timer: 2000,
            timerProgressBar: true,
          });
        } else {
          swal.fire({
            title: "Error",
            text: "An error occurred while deleting the time-off record.",
            icon: "error",
            buttonsStyling: false,
            customClass: {
              confirmButton: "gts-btn-primary",
            },
          });
        }
      },
      error: (error) => {
        this.showMessageError();
      },
      complete: () => {
        this.loadingFormTimeOff = false;
        this.getDataHDMode();
        this.getStatusHDMode();
      },
    });
  }

  //     response => {
  //       this.loadingFormTimeOff = false;
  //       if (response.status === 'success') {
  //         swal.fire({
  //           title: 'This time-off record has been successfully deleted.',
  //           icon: 'success',
  //           buttonsStyling: false,
  //           customClass: {
  //             confirmButton: 'gts-btn-primary'
  //           },
  //           timer: 2000,
  //           timerProgressBar: true
  //         });
  //         this.getDataHDMode();
  //       } else {
  //         swal.fire({
  //           title: 'Error',
  //           text: 'An error occurred while deleting the time-off record.',
  //           icon: 'error',
  //           buttonsStyling: false,
  //           customClass: {
  //             confirmButton: 'gts-btn-primary'
  //           }
  //         });
  //       }
  //     },

  //     error => {
  //       console.error(error);
  //       this.loadingFormTimeOff = false;
  //       this.showMessageError();
  //     }
  //   );
  // }

  setDataToFormTimeOff(id) {
    this.loadingFormTimeOff = true;
    this._companyLinkedService.getDetailTimeOff(this.token, id).subscribe({
      next: (response) => {
        this.timeOffForm = {
          id: response.data.id,
          assignmentType: response.data.assignmentType,
          assignHolidaysLeads: null,
          type: response.data.type,
          startDate: convertISODateStringToDate(response.data.startDate),
          hrInicio: response.data.horaInicio,
          endDate: convertISODateStringToDate(response.data.endDate),
          hrFin: response.data.horaFin,
          applyTo: response.data.applyTo,
        };
        if (response.data.assignmentType === "Random") {
          this.selectedValues = JSON.parse(response.data.extraData);
        } else {
          console.log(response.data.extraData, "extradata");
          this.selectedReps = JSON.parse(response.data.extraData);
        }
        this.loadingFormTimeOff = false;
        this.showFormHDMode("Edit");
      },
      error: (error) => {
        this.showMessageError();
        this.resetTimeOffForm();
      },
      complete: () => {
        this.loadingFormTimeOff = false;
      },
    });
  }

  updateHDMode() {
    this.loadingFormTimeOff = true;
    const userObservables = this.selectedReps.map((id) =>
      this._remindersService.getUser(id)
    );
    console.log(this.selectedReps, "this are selected");
    forkJoin(userObservables).subscribe({
      next: (responses) => {
        // Llenar el array newreps con los datos obtenidos
        this.newreps = responses
          .filter((response) => response.status === "success")
          .map((response) => ({
            id: response.data.id,
            name: response.data.name,
            surname: response.data.surname,
          }));

        this.timeOffForm.assignHolidaysLeads =
          this.timeOffForm.assignmentType === "Random"
            ? this.selectedValues
            : this.titleFormHDMode == "Edit"
            ? this.newreps
            : this.selectedReps;

        if (this.timeOffForm.type === "permanent") {
          delete this.timeOffForm.startDate;
          delete this.timeOffForm.hrInicio;
          delete this.timeOffForm.endDate;
          delete this.timeOffForm.hrFin;
        } else {
          this.timeOffForm.startDate = convertDateToISODateString(
            this.timeOffForm.startDate
          );
          this.timeOffForm.endDate = convertDateToISODateString(
            this.timeOffForm.endDate
          );
        }

        this._companyLinkedService
          .updateTimeOff(this.token, this.timeOffForm, this.timeOffForm.id)
          .subscribe({
            next: (response) => {
              if (response.status === "success") {
                swal.fire({
                  title: "This time-off record has been updated.",
                  icon: "success",
                  buttonsStyling: false,
                  customClass: {
                    confirmButton: "gts-btn-primary",
                  },
                  timer: 2000,
                  timerProgressBar: true,
                });
              }
            },

            error: (error) => {
              this.showMessageError();
            },
            complete: () => {
              this.loadingFormTimeOff = false;
              this.resetTimeOffForm();
              this.getDataHDMode();
              this.getStatusHDMode();
            },
          });
      },
      error: (error) => {
        console.error("Error al obtener usuarios:", error);
        this.showMessageError();
        this.loadingFormTimeOff = false;
      },
    });
  }
  showMessageError() {
    swal.fire({
      title: "Error",
      text: "An unexpected error occurred.",
      icon: "error",
      buttonsStyling: false,
      customClass: {
        confirmButton: "gts-btn-primary",
      },
    });
  }

  statusHDMode = 0;

  getStatusHDMode() {
    this._companyLinkedService.getDetailStatusHDMode(this.token).subscribe({
      next: (response) => {
        if (response.status === "success") {
          this.statusHDMode = response.data.holidaysLeads;
        }
      },
      error: (error) => {
        this.showMessageError();
      },
      complete: () => {},
    });
  }

  saveCompany() {
    if (!this.company.holidaysLeads) {
      this.company.assignHolidaysLeads = null;
    } else if (this.company.typeHolidaysLeads === "Random") {
      this.company.assignHolidaysLeads = this.selectedValues;
    } else if (this.company.typeHolidaysLeads === "Rep") {
      this.company.assignHolidaysLeads = this.selectedReps;
    }
    this.saving = true;
    this._companyLinkedService
      .editCompanySetup(this.token, this.company, this.company.id)
      .subscribe(
        (response) => {
          console.log(response);
          this.mtds.notifySuccess("Holidays configuration has been updated");
          this.closeConfig();
          this.saving = false;
        },
        (error) => {
          this.saving = false;
          this.mtds.notifyError(error.statusText, error.status);
        }
      );
  }

  saveassignbulkRep() {
    this.asignando = true;

    let json = {
      rep_id: this.repId,
      commentsAdmin: this.comentarios,
      bulk: this.bulk,
    };

    this._ContactFormService.assignBulkRep(this.token, json).subscribe(
      (r) => {
        console.log(r);
        if (r.code === 400 && r.msg === "Authorization not valid") {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else if (r.code === 200) {
          this.mtds.notifySuccess("Elements have been assigned successfully");
          this.cambiar(this.assigned);
          this.finassignbulkRep();
        } else {
          this.mtds.notifyError(r.msg, r.code);
        }
        this.asignando = false;
      },
      (e) => {
        console.log(e);
        this.mtds.notifyError(e.statusText);
        this.asignando = false;
      }
    );
  }

  finassignbulkRep() {
    $("#assignBulkModal").modal("hide");
    this.repId = null;
    this.comentarios = "";
  }

  openModal(crud = "create", itemId = null) {
    this.newLead = {
      name: "",
      email: "",
      phone: "",
      location: "",
      country_id: 0,
      state_id: 0,
      city_id: 0,
      source: "",
      descripcion: "",
      isAssign: 0,
      company: "",
    };
    this.action = crud;
    this.selectId = itemId;
    $("#crudModal").modal("show");
  }

  end(f) {
    f.reset();
    $("#crudModal").modal("hide");
    this.action = "create";
  }

  guardar(form) {
    this.guardando = true;
    switch (this.action) {
      case "create":
        this._ContactFormService
          .create(this.token, this.newLead)
          .subscribe((response) => {
            if (response.code === 404) {
              this.mtds.notifyError("Your session has expired");
              localStorage.clear();
              this._router.navigate(["/pages/lock"]);
              return 0;
            }
            if (response.status == "success") {
              this.end(form);
              this.showSwal("success", "New Lead has been created");
              if (this.sinceDate === null) {
                this.getAllContactsForm();
              } else {
                this.getAllContactsFormByDate();
              }
            } else {
              this.showSwal("error");
            }
            this.guardando = false;
          });
        break;
      case "read":
        this.end(form);
        break;
      /*
      case 'update':
        this._ContactFormService.updateTruck(this.token, this.newLead, this.id).subscribe(
          response => {
            if (response.status == 'success') {
              this.end(form);
              this.showSwal('success', '¡Truck have been updated!');
            } else {
              this.showSwal('error');
            }
            this.guardando = false;
          }
        );
        break;
      case 'delete':
          this._ContactFormService.deleteContacts(this.token, this.selectId).subscribe(
            response => {
              if (response.status == 'success') {
                this.end(form);
                this.showSwal('success', 'Lead have been removed!');
                this.getAllContactsForm();
              } else {
                this.showSwal('error');
              }
              this.guardando = false;
            }
          );
        break;
        */
    }
  }

  accion(event) {
    console.log(event);

    switch (event.evento) {
      case "unassigned":
        this.removeRep(event.id);
        break;
      case "assigned":
        this.open(event.id, event.rep_id);
        break;
      case "show":
        this.getContactForm(event.id);
        break;
      case "banear":
        this.banear(event.rep_id);
      case "reload":
        this.cambiar(this.assigned);
        break;
      case "remove":
        this.eliminar(event.id);
        break;
      case "unblack":
        this.unblack(event.id);
        break;
    }
  }

  eliminar(id) {
    swal
      .fire({
        title: "Remove Lead",
        text: "Are you sure to delete this Lead?",

        showCancelButton: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-default",
        },
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Continue",
      })
      .then(
        function (result) {
          if (result.value) {
            this._ContactFormService.deleteContacts(this.token, id).subscribe(
              (response) => {
                if (response.status == "success") {
                  this.cambiar(this.assigned);
                } else {
                  alert("An error has occurred.");
                }
              },
              (error) => {
                console.log(<any>error);
              }
            );
          }
        }.bind(this)
      );
  }

  banear(email) {
    swal
      .fire({
        title: "Are you sure you want to block this contact?",
        text: "",

        showCancelButton: true,
        buttonsStyling: false,

        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-default",
        },
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Continue",
      })
      .then(
        function (result) {
          if (result.value) {
            let json = {
              email,
            };
            this._ContactFormService.banearContacts(this.token, json).subscribe(
              (response) => {
                if (
                  response.code === 400 &&
                  response.msg === "Authorization not valid"
                ) {
                  this.mtds.notifyError("Your session has expired");
                  localStorage.clear();
                  this._router.navigate(["/pages/lock"]);
                } else if (response.status === "success") {
                  this.mtds.notifySuccess(
                    "Contact has been blocked successfully"
                  );
                  this.cambiar(this.assigned);
                } else {
                  this.mtds.notifyError(response.msg, response.code);
                }
              },
              (error) => {
                this.mtds.notifyError(error.statusText, error.status);
                this.editandoScrap = false;
              }
            );
          }
        }.bind(this)
      );
  }

  unblack(id) {
    swal
      .fire({
        title: "Are you sure you want to unblock this contact?",
        text: "",

        showCancelButton: true,
        buttonsStyling: false,

        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-default",
        },

        confirmButtonColor: "#3085d6",
        confirmButtonText: "Continue",
      })
      .then(
        function (result) {
          if (result.value) {
            this._ContactFormService.unblackContacts(this.token, id).subscribe(
              (response) => {
                if (
                  response.code === 400 &&
                  response.msg === "Authorization not valid"
                ) {
                  this.mtds.notifyError("Your session has expired");
                  localStorage.clear();
                  this._router.navigate(["/pages/lock"]);
                } else if (response.status === "success") {
                  this.mtds.notifySuccess(
                    "Contact has been unblocked successfully"
                  );
                  this.cambiar(this.assigned);
                } else {
                  this.mtds.notifyError(response.msg, response.code);
                }
              },
              (error) => {
                this.mtds.notifyError(error.statusText, error.status);
                this.editandoScrap = false;
              }
            );
          }
        }.bind(this)
      );
  }

  ngOnInit() {
    this.optionsButtonSelect = [
      { label: "All", value: "all" },
      { label: "Assigned", value: "assigned" },
      { label: "Unassigned", value: "unassigned" },
      { label: "Blacklist", value: "blacklist" },
      { label: "News Letter", value: "newsletter" },
    ];
    this.optionSelectMenuTrigger = "unassigned";

    this.getCountries();
    this.getStatusHDMode();
    this.filteredStates = this.stateControl.valueChanges.pipe(
      startWith(""),
      map((value) => this._filter(value, this.states))
    );
    this.filteredCities = this.cityControl.valueChanges.pipe(
      startWith(""),
      map((value) => this._filter(value, this.cities))
    );
    if (this.identity == null && this.identity.sub) {
      localStorage.clear();
      this._router.navigate(["/pages/lock"]);
    } else {
      this.searching = true;

      this._config.getConfig("leadslist").subscribe(
        (r) => {
          if (r.data) {
            this.options = JSON.parse(r.data.data);
          } else {
            //this.tablaDinamicaSet = false;
            this.options = this.mtds.colopt(this.dataUnassigned.headers, [
              false,
            ]);
            /*this.options = this.mtds.colopt(
              [
                "Check",
                "ID",
                "Name",
                "Company",
                "Phone",
                "Email",
                "Location",
                "Date",
                "Rep",
                "Actions",
              ],
              [true, false]
            );*/
          }
          this.cambiar("unassigned");
        },
        (error) => {
          this.mtds.notifyError(error.statusText, error.status);
          this.searching = false;
        }
      );
    }
    this.titleServices.setTitle("Leads");
    this.getCompany();
  }
  menuTriggerToShow(newValue: string) {
    console.log(newValue);
    this.assigned = newValue;
    this.cambiar(newValue);
  }
  updateConfig(e) {
    this.options = e;

    this._config.setConfig("leadslist", this.options).subscribe((r) => {});
  }

  removeRep(id) {
    this.selectedId = id;
    $("#removeModal").modal("show");
  }

  public sortStates = "";
  public filterrigh = "";
  handleRightClick(data: any): void {
    const columnKey = data.columnName.key;
    if (columnKey === this.filterrigh) {
      if (this.sortStates === "DESC") {
        this.sortStates = "ASC";
      } else {
        this.sortStates = "DESC";
      }
    } else {
      this.sortStates = "ASC";
    }
    this.filterrigh = columnKey;

    if (this.assigned !== "newsletter") {
      this.getAllContactsFormByDate(null,false);
    } else if (this.assigned == "newsletter") {
      this.getNewsletterContacts(null,false);
    }
  }

  cambiar(assigned: string) {
    this.assigned = assigned;

    this.bulk = [];
    this.asignarElementos = [];
    this.borrarElementos = [];
    this.bulkNewsletterContacts = [];
    this.filtros = [];
    this.filtrosnews = [];
    if (this.sinceDate == null) {
      console.log("getAllContactsForm launch");
      if (this.assigned === "newsletter") this.getNewsletterContacts();
      else this.getAllContactsForm();
    } else {
      console.log("getAllContactsFormByDate launch");
      if (this.assigned === "newsletter") this.getNewsletterContacts();
      else this.getAllContactsFormByDate();
    }

    /*
    var delayInMilliseconds = 1000;
    setTimeout(() => {
      this.assigned = assigned;
      this.searching = false;
    }, delayInMilliseconds);
    */
  }

  remove() {
    this.guardando = true;
    this._ContactFormService
      .unassignedRep(this.token, this.selectedId)
      .subscribe(
        (response) => {
          if (response.status === 404) {
            this.mtds.notifyError("Your session has expired");
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
            return 0;
          }
          if (response.status === "success") {
            this.showSwal("success", "The contact form rep has been removed!");
            // for (let item of this.tableContactForm.dataRows) {
            //   if (item[0] == this.selectedId) {
            //     item[7] = '';
            //     item[8] = '';
            //     break;
            //   }
            // }
            if (this.sinceDate == null) {
              this.getAllContactsForm();
            } else {
              this.getAllContactsFormByDate();
            }
          } else {
            this.showSwal("error");
          }
          this.close();
          this.guardando = false;
        },
        (error) => {
          this.showSwal("error");
          this.close();
          this.guardando = false;
        }
      );
  }

  open(id, repId) {
    console.log("why", id, repId);
    this.selectedId = id;
    this.repId = repId;
    $("#myModal").modal("show");
  }

  close() {
    this.repId = "";
    this.selectedId = "";
    this.comentarios = "";
    $("#myModal").modal("hide");
    $("#removeModal").modal("hide");
  }

  save() {
    this.guardando = true;
    let data = {
      rep_id: this.repId,
      commentsAdmin: this.comentarios,
    };
    this._ContactFormService
      .assingRep(this.token, this.selectedId, data)
      .subscribe(
        (response) => {
          if (response.code === 404) {
            this.mtds.notifyError("Your session has expired");
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
            return 0;
          }
          if (response.status === "success") {
            this.showSwal("success", "The rep has been assigned successfully!");
            console.log(response);
            // for (let item of this.tableContactForm.dataRows) {
            //   if (item[0] == this.selectedId) {
            //     for (let rep of this.repsList) {
            //       if (this.repId == rep.id) {
            //         item[7] = rep.name + ' ' + rep.surname;
            //         item[8] = rep.id;
            //         break;
            //       }
            //     }
            //     break;
            //   }
            // }
            if (this.sinceDate == null) {
              this.getAllContactsForm();
            } else {
              this.getAllContactsFormByDate();
            }
            this.myWebSocket.next({
              notify: "1",
              data: response.data.id,
              type: "",
              token: this.token,
              action: "NEW", // NEW ó UPDATE ó DELETE
            });

            this.myWebSocket.asObservable().subscribe(
              (msg) => {
                let msgCoded;
                msgCoded = JSON.stringify(msg);
                console.log("message received: " + msgCoded);
                this.numberNotifications = msg.numberNotifications;
                this.notificationsData = msg.data;
              },
              // Called whenever there is a message from the server
              (err) => console.log(err),
              // Called if WebSocket API signals some kind of error
              () => console.log("complete")
              // Called when connection is closed (for whatever reason)
            );
          } else {
            this.showSwal("error");
          }
          this.close();
          this.guardando = false;
        },
        (error) => {
          this.guardando = false;
          this.showSwal("error");
          this.close();
        }
      );
  }

  getAllContactsForm() {
    this.searching = true;
    this.contactFormsAssigned = [];
    this.contactFormsUnassigned = [];
    this.contactFormsAll = [];
    this.bulk = [];
    this.asignarElementos = [];
    this.borrarElementos = [];
    let data = { type: this.assigned };

    this._ContactFormService.getContactsByType(this.token, 1, data).subscribe(
      (response) => {
        if (response.status == "success") {
          // this.itemsPorPagina = response.items_per_page;
          // this.paginaActual = response.page_actual;
          // this.totalItems = response.total_items_count;
          // this.totalPaginas = response.total_pages;
          // this.contacts = response.data;
          this.contacts.forEach(
            function (element) {
              let rep = "";
              let repId = "";
              if (element.rep !== null) {
                rep = element.rep.name + " " + element.rep.surname;
                repId = element.rep.id;
                this.repId = element.rep.id;

                this.contactFormsAssigned.push([
                  element.id,
                  element.name,
                  element.phone,
                  element.email,
                  element.location,
                  element.fecha,
                  element.descripcion,
                  rep,
                  repId,
                  element.company,
                  element.status,
                ]);
              } else {
                let actionButtons = [
                  {
                    icon: "delete_outline",
                    action: "Remove",
                    color: "danger",
                    value: element.id,
                  },
                ];
                let country = "";
                let state = "";
                let city = "";
                if (element.ipinfoCountry) {
                  country = element.ipinfoCountry;
                } else if (element.country?.country) {
                  country = element.country.country;
                } else {
                  country = element.location;
                }

                if (element.ipinfoRegionname) {
                  state = element.ipinfoRegionname;
                } else if (element.state?.state) {
                  state = element.state.state;
                } else {
                  state = "";
                }

                if (element.ipinfoCity) {
                  city = element.ipinfoCity;
                } else if (element.city?.city) {
                  city = element.city.city;
                } else {
                  city = "";
                }
                const dateStamp = element.fecha;
                let fechaFormateada = "";
                
                
                if (dateStamp !== undefined && dateStamp !== -62169962964) {
                  const dateObj = new Date(dateStamp * 1000);
                  
                  if (!isNaN(dateObj.getTime())) {
                    fechaFormateada = this.datePipe.transform(
                      dateObj,
                      'MM/dd/yyyy',
                      'UTC'
                    );
                  }
                }
                this.dataUnassigned.rows.push([
                  new Cell(element.id, { type: "checkbox" }),
                  new Cell(element.id),
                  new Cell(element.name),
                  new Cell(element.company),
                  new Cell(element.phone),
                  new Cell(element.email),
                  //new Cell(element.location),
                  new Cell(country),
                  new Cell(state),
                  new Cell(city),
                  new Cell(fechaFormateada),
                  // new Cell(element.descripcion),
                  new Cell(
                    repId
                      ? rep
                      : !repId && element.status !== "BLACKLISTED"
                      ? "Assign to"
                      : element.status == "BLACKLISTED"
                      ? "Blacklisted"
                      : ""
                  ),
                  new Cell(actionButtons, { type: "actions" }),
                ]);
              }
              this.contactFormsAll.push([
                element.id,
                element.name,
                element.phone,
                element.email,
                element.location,
                element.fecha,
                element.descripcion,
                rep,
                repId,
                element.company,
                element.status,
              ]);
            }.bind(this)
          );
        } else {
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        }
        this.searching = false;
      },
      (error) => {
        console.log(<any>error);
        this.searching = false;
      }
    );
  }

  getAllContactsFormByDate(e = null, newfilter = true) {
    this.searching = true;
    this.contactFormsAssigned = [];
    this.contactFormsUnassigned = [];
    this.contactFormsAll = [];
    //this.bulk = [];
    this.asignarElementos = [];
    this.borrarElementos = [];
    this._route.params.forEach((params: Params) => {
      let data = {
        type: this.assigned,
        date1: this.getFormattedDate(this.sinceDate),
        date2: this.getFormattedDate(this.toDate),
        busqueda:
          e !== null
            ? (this.campoBusqueda = e.search)
            : (this.campoBusqueda = ""),
        sort: [this.filterrigh],
        order: this.sortStates,
      };
      this._ContactFormService
        .getContactsByDate(
          this.token,
          data,
          e !== null ? e.page : 1,
          e !== null ? e.perPage : 10,
          e !== null
            ? (this.campoBusqueda = e.search)
            : (this.campoBusqueda = ""),
          this.filtros
        )
        .subscribe(
          (response) => {
            if (response.status == "success") {
              //console.log(response);
              // this.itemsPorPagina = response.items_per_page;
              // this.paginaActual = response.page_actual;
              // this.totalItems = response.total_items_count;
              // this.totalPaginas = response.total_pages;

              this.paginaActual = Number(response.page_actual);
              this.itemsPorPagina = String(response.items_per_page);
              this.totalItems = Number(response.total_items_count);
              this.totalPaginas = Number(response.total_pages);

              if (newfilter) {
                this.filtros = [
                  null,
                  {
                    key: "filter_id",
                    title: "ID",
                    value: "",
                    type: "contains",
                    key_type: "filter_id_type",
                    type_options: [
                      { value: "nofilter", name: "No Filter" },
                      { value: "contains", name: "Contains" },
                      { value: "startswith", name: "Starts With" },
                      { value: "endswith", name: "Ends With" },
                      { value: "equalto", name: "Equal To" },
                    ],
                  },
                  {
                    key: "filter_name",
                    title: "Name",
                    value: "",
                    type: "contains",
                    key_type: "filter_name_type",
                    type_options: [
                      { value: "nofilter", name: "No Filter" },
                      { value: "contains", name: "Contains" },
                      { value: "startswith", name: "Starts With" },
                      { value: "endswith", name: "Ends With" },
                      { value: "equalto", name: "Equal To" },
                    ],
                  },
                  {
                    key: "filter_company",
                    title: "Company",
                    value: "",
                    type: "contains",
                    key_type: "filter_company_type",
                    type_options: [
                      { value: "nofilter", name: "No Filter" },
                      { value: "contains", name: "Contains" },
                      { value: "startswith", name: "Starts With" },
                      { value: "endswith", name: "Ends With" },
                      { value: "equalto", name: "Equal To" },
                    ],
                  },
                  {
                    key: "filter_phone",
                    title: "Phone",
                    value: "",
                    type: "equalto",
                    key_type: "filter_phone_type",
                    type_options: [
                      { value: "nofilter", name: "No Filter" },
                      { value: "contains", name: "Contains" },
                      { value: "startswith", name: "Starts With" },
                      { value: "endswith", name: "Ends With" },
                      { value: "equalto", name: "Equal To" },
                    ],
                  },
                  {
                    key: "filter_email",
                    title: "Email",
                    value: "",
                    type: "equalto",
                    key_type: "filter_email_type",
                    type_options: [
                      { value: "nofilter", name: "No Filter" },
                      { value: "contains", name: "Contains" },
                      { value: "startswith", name: "Starts With" },
                      { value: "endswith", name: "Ends With" },
                      { value: "equalto", name: "Equal To" },
                    ],
                  },
                  {
                    key: "filter_country",
                    title: "Country",
                    value: "",
                    type: "equalto",
                    key_type: "filter_country_type",
                    type_options: [
                      { value: "nofilter", name: "No Filter" },
                      { value: "contains", name: "Contains" },
                      { value: "startswith", name: "Starts With" },
                      { value: "endswith", name: "Ends With" },
                      { value: "equalto", name: "Equal To" },
                    ],
                  },
                  {
                    key: "filter_state",
                    title: "State",
                    value: "",
                    type: "equalto",
                    key_type: "filter_state_type",
                    type_options: [
                      { value: "nofilter", name: "No Filter" },
                      { value: "contains", name: "Contains" },
                      { value: "startswith", name: "Starts With" },
                      { value: "endswith", name: "Ends With" },
                      { value: "equalto", name: "Equal To" },
                    ],
                  },
                  {
                    key: "filter_city",
                    title: "City",
                    value: "",
                    type: "equalto",
                    key_type: "filter_city_type",
                    type_options: [
                      { value: "nofilter", name: "No Filter" },
                      { value: "contains", name: "Contains" },
                      { value: "startswith", name: "Starts With" },
                      { value: "endswith", name: "Ends With" },
                      { value: "equalto", name: "Equal To" },
                    ],
                  },
                  {
                    key: "filter_date",
                    title: "Date",
                    value: "",
                    type: "startswith",
                    key_type: "filter_date_type",
                    type_options: [
                      { value: 'nofilter', name: 'No Filter' }, { value: 'equalto', name: 'Equal To' }, { value: 'notequalto', name: 'Not Equal To' }, { value: 'greaterthan', name: 'Greater Than' }, { value: 'lessthan', name: 'Less Than' }
                    ],
                  },
                  {
                    key: "filter_source",
                    title: "Source",
                    value: "",
                    type: "equalto",
                    key_type: "filter_source_type",
                    type_options: [
                      { value: "nofilter", name: "No Filter" },
                      { value: "contains", name: "Contains" },
                      { value: "startswith", name: "Starts With" },
                      { value: "endswith", name: "Ends With" },
                      { value: "equalto", name: "Equal To" },
                    ],
                  },
                  {
                    key: "filter_ranking",
                    title: "Ranking",
                    value: "",
                    type: "equalto",
                    key_type: "filter_ranking_type",
                    type_options: [
                      { value: "nofilter", name: "No Filter" },
                      { value: "contains", name: "Contains" },
                      { value: "startswith", name: "Starts With" },
                      { value: "endswith", name: "Ends With" },
                      { value: "equalto", name: "Equal To" },
                    ],
                  },
                  {
                    key: "filter_description",
                    title: "Description",
                    value: "",
                    type: "multipleword",
                    key_type: "filter_description_type",
                    type_options: [
                      { value: "multipleword", name: "Multiple Words" }
                    ],
                  },
                  {
                    key: "filter_rep",
                    title: "Rep",
                    value: "",
                    type: "equalto",
                    key_type: "filter_rep_type",
                    type_options: [
                      { value: "nofilter", name: "No Filter" },
                      { value: "contains", name: "Contains" },
                      { value: "startswith", name: "Starts With" },
                      { value: "endswith", name: "Ends With" },
                      { value: "equalto", name: "Equal To" },
                    ],
                  },
                  null,
                ];
              }

              this.dataUnassigned.rows = [];
              this.contacts = response.data;
              console.log("resp data", response);

              this.contacts.forEach(
                function (element) {
                  // console.log(element);
                  // console.log(element, "dataaa");

                  let selected_value = false;

                  if (this.bulk.includes(element.id.toString()))
                    selected_value = true;

                  let rep = "";
                  let repId = "";
                  if (element.rep !== null) {
                    rep = element.rep.name + " " + element.rep.surname;
                    repId = element.rep.id;
                    this.repId = repId;
                  }

                  let actionButtons = [
                    {
                      icon: "delete_outline",
                      action: "Remove",
                      color: "danger",
                      value: element.id,
                    },
                    {
                      icon: "remove_red_eye",
                      action: "Detail",
                      color: "info",
                      value: element.id,
                    },
                  ];
                  if (element.status !== "BLACKLISTED") {
                    actionButtons.push({
                      icon: "block",
                      action: "Block",
                      color: "danger",
                      value: element.email,
                    });
                  }
                  if (repId && element.status !== "BLACKLISTED") {
                    actionButtons.push({
                      icon: "group_off",
                      action: "Unassign",
                      color: "danger",
                      value: element.id,
                    });
                  }
                  if (element.status == "BLACKLISTED") {
                    actionButtons.push({
                      icon: "lock_open",
                      action: "unblack",
                      color: "dark",
                      value: element.id,
                    });
                  }
                  let label = null;
                  let classes = null;
                  let type = "button";
                  if (!repId) {
                    if (element.status == "BLACKLISTED") {
                      label = "Blacklisted";
                      type = "txt";
                    } else {
                      label = "Assign to";
                      classes = "btn-warning";
                    }
                  } else {
                    type = "text";
                  }

                  let country = "";
                  let state = "";
                  let city = "";
                  if (element.ipinfoCountry) {
                    country = element.ipinfoCountry;
                  } else if (element.country?.country) {
                    country = element.country.country;
                  } else {
                    country = element.location;
                  }

                  if (element.ipinfoRegionname) {
                    state = element.ipinfoRegionname;
                  } else if (element.state?.state) {
                    state = element.state.state;
                  } else {
                    state = "";
                  }

                  if (element.ipinfoCity) {
                    city = element.ipinfoCity;
                  } else if (element.city?.city) {
                    city = element.city.city;
                  } else {
                    city = "";
                  }
                  const dateStamp = element.fecha;
                  let fechaFormateada = "";
                  
                  
                  if (dateStamp !== undefined && dateStamp !== -62169962964) {
                    const dateObj = new Date(dateStamp * 1000);
                    
                    if (!isNaN(dateObj.getTime())) {
                      fechaFormateada = this.datePipe.transform(
                        dateObj,
                        'MM/dd/yyyy',
                        'UTC'
                      );
                    }
                  }
                  this.dataUnassigned.rows.push([
                    new Cell(element.id, {
                      type: "checkbox",
                      selected: selected_value,
                    }), // Check box
                    new Cell(element.id),
                    new Cell(element.name),
                    new Cell(element.company),
                    new Cell(element.phone),
                    new Cell(element.email),
                    //new Cell(element.location),
                    new Cell(country),
                    new Cell(state),
                    new Cell(city),
                    new Cell(fechaFormateada),
                    new Cell(element.source),
                    new Cell(element.ranking),
                    new Cell(element.descripcion, {style: 'width:180px!important; min-width:180px!important;' }),
                    new Cell(repId ? rep : label, {
                      type: type,
                      class: classes,
                    }),
                    new Cell(actionButtons, { type: "actions" }),
                  ]);
                }.bind(this)
              );
            } else {
              /*localStorage.clear();
            this._router.navigate(["/pages/lock"]);*/
            }
            this.searching = false;
          },
          (error) => {
            console.log(<any>error);
            this.searching = false;
          }
        );
    });
  }

  getContactForm(id: number) {
    this._route.params.forEach((params: Params) => {
      let page = +params["page"];

      if (!page) {
        page = 1;
      }

      this._ContactFormService.getContact(this.token, id).subscribe(
        (response) => {
          console.log(response);
          if (response.status == "success") {
            this.contact = response.data;
            console.log(this.contact);
            let dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
              width: "80%",
              data: { contact: this.contact },
              autoFocus: false,
            });
            dialogRef.afterClosed().subscribe((result) => {
              //this.getAllContactsForm();
            });
          } else {
            // localStorage.clear();
            // this._router.navigate(["/pages/lock"]);
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
    });
    //this.ngOnInit();
  }

  /*openDialog(): void {
    console.log("entramos");
    let dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
      width: '80%',
      data: { contact: this.contact}
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getAllContactsForm();
    });
  }*/

  deleteContact() {
    let id = $("#borrarContact").val();
    this._ContactFormService.deleteContacts(this.token, id).subscribe(
      (response) => {
        if (response.status == "success") {
          //this._router.navigate(['/']);
          // this.getAllPacientes();
        } else {
          alert("An error has occurred.");
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }

  getFecha(fecha: Date) {
    let dia;
    dia = fecha.getDate();
    let day;
    if (dia < 10) {
      day = "0" + dia;
    } else {
      day = dia;
    }
    let mes;
    mes = fecha.getMonth() + 1;
    let month;
    if (mes < 10) {
      month = "0" + mes;
    } else {
      month = mes;
    }
    let anio = fecha.getFullYear();

    return anio + "-" + month + "-" + day;
  }

  showSwal(type, title = "", message = "") {
    if (type === "success") {
      swal.fire({
        title: title,
        text: message,
        buttonsStyling: false,

        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    } else if (type === "error") {
      swal.fire({
        title: "ERROR!",
        text: "An error has ocurred.",
        buttonsStyling: false,

        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    }
  }

  // *************************************************** NEW UI ************************************

  newUI = true;

  getFormattedDate(date: Date): string {
    return this.datePipe.transform(date, "yyyy-MM-dd");
  }

  private _filter(value: string, options: any[]): any[] {
    const filterValue = value.toLowerCase();
    return options.filter(
      (option) =>
        (option.state && option.state.toLowerCase().includes(filterValue)) ||
        (option.city && option.city.toLowerCase().includes(filterValue))
    );
  }
  getCountries() {
    this._ContactFormService.getCountries().subscribe((data) => {
      if (data.status === "success") {
        this.countries = data.data;
      }
    });
  }

  getStates() {
    if (this.newLead.country_id) {
      this._ContactFormService
        .getStates(this.newLead.country_id)
        .subscribe((data) => {
          if (data.status === "success") {
            this.states = data.data;
            this.stateControl.setValue("");
          }
        });
    }
  }
  onStateSelected(event) {
    const state = event.option.value;
    this.newLead.state_id = this.states.find((s) => s.state === state).id;
    this.getCities();
  }
  getCities() {
    if (this.newLead.state_id) {
      this._ContactFormService
        .getCities(this.newLead.state_id)
        .subscribe((data) => {
          if (data.status === "success") {
            this.cities = data.data;
            this.cityControl.setValue("");
          }
        });
    }
  }
  onCitySelected(event) {
    const city = event.option.value;
    this.newLead.city_id = this.cities.find((c) => c.city === city).id;
  }
}

@Component({
  // selector: "dialog-overview-example-dialog",
  // templateUrl: "dialog-overview-example-dialog.html",
  selector: "dialog-overview-example-dialog",
  templateUrl: "lead-detail.component.html",
  styleUrls: ["./lead-detail.component.css"],
  providers: [
    ContactHistoryService,
    UserService,
    ReminderService,
    ContactsFormService,
    ConfigService,
  ],
})
export class DialogOverviewExampleDialog implements AfterViewInit {
  stateControl = new FormControl();
  cityControl = new FormControl();
  activeTabIndex = 0;

  public mtds: Methods = new Methods();

  public idcontact;
  public token;
  public identity;
  public statusLead;
  public contacthistory: Reminder;
  public status_contactHistory;
  public userinterno;
  public editHistory = false;
  public saveEditHistory = false;

  public editContact = true;
  public saveContact = false;

  /*NEW SECTION DINAMIC TABLE*/
  public loading = false;

  public contacts: DinamicData = new DinamicData([
    "ID",
    "REP",
    "Contact Date",
    "Reminder Date",
    "Description",
    "Actions",
  ]);

  public filtros = [];

  public campoBusqueda = "";
  public paginaActual = 1;
  public itemsPorPagina = "10";
  public totalItems = 0;
  public totalPaginas = 1;

  public options: Array<any> = [];

  //Usuarios Reminders
  filteredArrayUsers: Observable<UserList[]>;
  myControlUsers = new FormControl();
  public usersSeleccionados = [];
  public arrayUsers: any[] = [];

  public tableContacts: TableData;
  public rankings = [
    {
      value: "Vendor",
      label: "VENDOR",
      src: "/assets/img/faces/trophy.svg",
    },
    {
      value: "Customer",
      label: "CUSTOMER",
      src: "/assets/img/faces/trophy.svg",
    },
    {
      value: "Great",
      label: "GREAT LEAD",
      src: "/assets/img/faces/medal.svg",
    },
    {
      value: "Okay",
      label: "OKAY LEAD",
      src: "/assets/img/faces/good.svg",
    },
    {
      value: "Poor",
      label: "POOR LEAD",
      src: "/assets/img/faces/bad.svg",
    },
    {
      value: "Junk",
      label: "JUNK",
      src: "/assets/img/faces/bin.svg",
    },
    {
      value: "TBD",
      label: "TBD",
      src: "/assets/img/faces/clock.svg",
    },
  ];
  public sources = [
    "Website",
    "Incoming Call",
    "Cold Call",
    "Referral",
    "Zoom",
    "Walk-In",
    "MXWebsite",
  ];
  constructor(
    private _ContactFormService: ContactsFormService,
    private _userService: UserService,
    private _reminderService: ReminderService,
    private _router: Router,
    private _config: ConfigService,
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.identity = this._userService.getIdentity();
    console.log(this.identity);
    this.token = this._userService.getToken();

    console.log("data => ", data);

    if (data.user) {
      this.userinterno = data.user;
    } else {
      this.userinterno = [];
    }

    var html = data.contact.descripcion;
    var div = document.createElement("div");
    div.innerHTML = html;
    data.contact.descripcion = div.innerText;
    this.idcontact = data.contact.id;
    this.statusLead = data.contact.ranking;
    this.getAllContacts();
    this.getUsers();
  }

  openUsersModal() {
    $("#enableUsersModal").modal("show");
  }

  closeUsersModal(option: any) {
    if (option == 1) {
      this.usersSeleccionados = [];
    }
    $("#enableUsersModal").modal("hide");
  }

  seleccionarUser(id) {
    let numero: number, encontrado: boolean, index: number;
    index = 0;
    encontrado = false;
    for (numero of this.usersSeleccionados) {
      if (numero === id) {
        encontrado = true;
        this.usersSeleccionados.splice(index, 1);
        let json;

        json = {
          type: "DELETEUSER",
          data: numero,
        };

        /*this._notificationService.editNotification(this.token, this.editNotification, json).subscribe(
          response => {
          }
        );*/
        break;
      }
      index++;
    }

    if (!encontrado) {
      this.usersSeleccionados.push(id);
      let json;

      json = {
        type: "ADDUSER",
        data: id,
      };

      /*this._notificationService.editNotification(this.token, this.editNotification, json).subscribe(
          response => {
          }
        );*/
    }
  }

  chequeadoUser(id) {
    let numero: number;
    for (numero of this.usersSeleccionados) {
      if (numero === id) {
        return true;
      }
    }

    return false;
  }

  private _filterUsers(name: string): UserList[] {
    const filterValue = name.toLowerCase();

    return this.arrayUsers.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  close() {
    this.dialogRef.close();
  }

  addZero(i) {
    if (i < 10) {
      i = "0" + i;
    }
    return i;
  }

  ngOnInit() {
    this.getCountries();

    this.filteredStates = this.stateControl.valueChanges.pipe(
      startWith(""),
      map((value) => this._filter(value, this.states))
    );
    this.filteredCities = this.cityControl.valueChanges.pipe(
      startWith(""),
      map((value) => this._filter(value, this.cities))
    );

    var today = new Date();
    var date =
      today.getFullYear() +
      "-" +
      (this.addZero(today.getMonth()) + 1) +
      "-" +
      this.addZero(today.getDate());
    var time =
      this.addZero(today.getHours()) +
      ":" +
      this.addZero(today.getMinutes()) +
      ":" +
      this.addZero(today.getSeconds());

    if (this.identity == null && this.identity.sub) {
      this._router.navigate(["/pages/lock"]);
    } else {
      this.contacthistory = new Reminder(
        1,
        this.idcontact,
        this.identity.sub,
        "",
        "",
        today,
        time,
        "",
        "LEAD",
        "",
        0,
        0,
        "",
        ""
      );
    }
    this.filteredArrayUsers = this.myControlUsers.valueChanges.pipe(
      startWith<string | UserList>(""),
      map((value) => (typeof value === "string" ? value : value.name)),
      map((name) => (name ? this._filterUsers(name) : this.arrayUsers.slice()))
    );

    if (!this.data.contact.country) {
      this.data.contact.country = { id: null, country: "" };
    }
    if (!this.data.contact.state) {
      this.data.contact.state = { id: null, state: "" };
    }
    if (!this.data.contact.city) {
      this.data.contact.city = { id: null, city: "" };
    }

    this.getConfigTable();

    // TODO: When the dynamic table is implemented, this setTimeout must be removed, it was added so that it would not give an error when loading the modal, also remove tableDinamic and its implementation in the html
    /*setTimeout(() => {
      this.tableDinamic= true;
    }, 1000);*/
  }
  //tableDinamic= false;

  getConfigTable() {
    //this.loading = true;
    this._config.getConfig("contactHistory").subscribe(
      (r) => {
        if (r.data) {
          this.options = JSON.parse(r.data.data);
        } else {
          this.options = this.mtds.colopt(this.contacts.headers, [false]);
        }

        this.getAllContacts();
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
        //this.loading = false;
      }
    );
  }

  updateConfig(e) {
    this.options = e;
    console.log(this.options);
    this._config.setConfig("contactHistory", this.options).subscribe((r) => {
      console.log(r);
    });
  }

  editContactFunction() {
    this.saveContact = true;
    this.data.contact.city_id = this.data.contact.city.id;
    this.data.contact.country_id = this.data.contact.country.id;
    this.data.contact.state_id = this.data.contact.state.id;

    this._ContactFormService
      .edit(this.token, this.data.contact, this.data.contact.id)
      .subscribe(
        (response) => {
          if (response.status !== "success") {
            this.showSwal("error", "Contact not updated!");
          } else {
            this.showSwal("success", "Contact updated!");
            this.onToggleChange();
          }
          this.saveContact = false;
        },
        (error) => {
          console.log(<any>error);
          this.saveContact = false;
        }
      );
  }

  getContactHistory(id) {
    this.editHistory = true;
    this._reminderService.getContact(this.token, id).subscribe((response) => {
      console.log(response, "resp");
      this.contacthistory.id = response.data.id;
      let fechaContacto = this.setDate(
        response.data.fechacontacto,
        response.data.horacontacto
      );
      this.contacthistory.fechacontacto = this.convertDate(
        fechaContacto,
        "yyyy-mm-dd"
      );

      this.contacthistory.horacontacto = response.data.horacontacto;
      this.contacthistory.reminder = response.data.reminder;
      let fecha = this.setDate(response.data.fecha, response.data.hora);
      this.contacthistory.fecha = this.convertDate(fecha, "yyyy-mm-dd");

      this.contacthistory.hora = response.data.hora;
      this.contacthistory.descripcion = response.data.descripcion;
      this.contacthistory.email = response.data.email;
      this.contacthistory.notification = response.data.notification;
    });
    this.showFormContactH("Edit");
  }

  cleanContact() {
    let today = new Date();
    let date =
      today.getFullYear() +
      "-" +
      (this.addZero(today.getMonth()) + 1) +
      "-" +
      this.addZero(today.getDate());
    let time =
      this.addZero(today.getHours()) +
      ":" +
      this.addZero(today.getMinutes()) +
      ":" +
      this.addZero(today.getSeconds());
    this.contacthistory = new Reminder(
      1,
      this.idcontact,
      this.identity.sub,
      "",
      "",
      today,
      time,
      "",
      "LEAD",
      "",
      0,
      0,
      "",
      ""
    );
    this.editHistory = false;
    this.showFormContactH("New");
  }

  isValidDate(value: any): boolean {
    const date = new Date(value);
    return !isNaN(date.getTime());
  }

  action(e) {
    console.log(e);
    switch (e.action) {
      case "Remove":
        this.deleteContactHistory(e.id);
        break;
      case "Edit":
        this.getContactHistory(e.id);
        break;
      default:
        break;
    }
  }

  editContactHistory() {
    this.contacthistory.fecha = "";
    this.contacthistory.fecha = this.isValidDate(this.contacthistory.fecha)
      ? this.contacthistory.fecha
      : "";
    this.saveEditHistory = true;
    this._reminderService
      .update(this.token, this.contacthistory, this.contacthistory.id)
      .subscribe(
        (response) => {
          this.showSwal(
            "success",
            "Contact information has been updated successfully."
          );
          this.getAllContacts();
          this.cleanContact();
          this.saveEditHistory = false;
        },
        (error) => {
          this.showSwal(
            "error",
            "Something went wrong, it was not possible to save the changes."
          );
          this.saveEditHistory = false;
        }
      );
  }

  deleteContactHistory(id) {
    swal
      .fire({
        title: "Delete Contact History",
        text: "Are you sure you want to delete this contact history",

        showCancelButton: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-default",
        },
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, remove it",
      })
      .then(
        function (result) {
          if (result.value) {
            this._reminderService.deleteContact(this.token, id).subscribe(
              (response) => {
                this.getAllContacts();
              },
              (error) => {
                alert("Something went wrong");
              }
            );
          }
        }.bind(this)
      );
  }

  getUsers() {
    this.arrayUsers = [];
    this._userService
      .getAllUsersLite(this._userService.getToken(), "exceptuser")
      .subscribe(
        (response) => {
          if (response.status === "success") {
            console.log(response);
            this.arrayUsers = response.data;
          } else {
            alert("Error");
          }
          console.log(this.arrayUsers);
        },
        (error) => {
          console.log(<any>error);
          alert("Error");
        }
      );
  }

  ngAfterViewInit() {
    var self = this; // get a reference to `this`
    $("#datatables1").DataTable({
      dom: "Bflrtip",
      buttons: [
        /*{
            extend: 'copy',
            exportOptions: {
              columns: ':visible'
            }
          },*/ /*
          {
            extend: 'csv',
            exportOptions: {
              columns: ':visible'
            }
          },*/
        {
          extend: "excel",
          text: '<i class="fa fa-file-excel-o"></i>',
          titleAttr: "Excel",
          className: "btn btn-sm btn-outline-success",
          exportOptions: {
            columns: ":visible",
          },
        },
        {
          extend: "pdf",
          text: '<i class="fa fa-file-pdf-o"></i>',
          titleAttr: "PDF",
          className: "btn btn-sm btn-outline-danger",
          exportOptions: {
            columns: ":visible",
          },
        },
        {
          extend: "print",
          text: '<i class="fa fa-print" aria-hidden="true"></i>',
          titleAttr: "print",
          className: "btn btn-sm btn-outline-primary",
          exportOptions: {
            columns: ":visible",
          },
        },
        {
          extend: "colvis",
          text: '<i class="fa fa-columns" aria-hidden="true"></i>',
          className: "btn btn-sm btn-outline-info",
          titleAttr: "Column visibility",
        },
      ],
      pagingType: "full_numbers",
      lengthMenu: [
        [10, 25, 50, -1],
        [10, 25, 50, "All"],
      ],
      responsive: true,
      language: {
        search: "_INPUT_",
        searchPlaceholder: "Search",
      },
    });

    const table1 = $("#datatables1").DataTable();
    // Edit record
    table1.on("click", ".edit", function (e) {
      e.preventDefault();
      const $tr = $(this).closest("tr");
      const data = table1.row($tr).data();
      console.log(
        "You press on Row: " +
          data[0] +
          " " +
          data[1] +
          " " +
          data[2] +
          "'s row."
      );
      //data.push(self.idPaciente);
      //self.openRegistroVisitas(data);
    });
    // Delete a record
    /*table1.on('click', '.remove', function(e) {
           const $tr = $(this).closest('tr');
           const data = table1.row($tr).data();

           table1.row($tr).remove().draw();
           self.deleteContactyHistory(data);
           e.preventDefault();
         });*/

    //Delete a record
    table1.on("click", ".remove", function (e) {
      e.preventDefault();
      var txt;
      var r = confirm("Are you sure to delete this registry?");
      if (r == true) {
        const $tr = $(this).closest("tr");
        const data = table1.row($tr).data();
        table1.row($tr).remove().draw();
        $("#borrarUser").val(data[0]);
        $("#borrarUser").trigger("click");
      } else {
      }
    });

    //Like record
    table1.on("click", ".like", function () {
      alert("You clicked on Like button");
    });

    $(".card .material-datatables label").addClass("form-group");
  }

  getAllContacts(e = null, newfilter = true) {
    this.loading = true;
    let json = {
      type: "LEAD",
      busqueda:
        e !== null
          ? (this.campoBusqueda = e.search)
          : (this.campoBusqueda = ""),
      contact: this.idcontact,
    };
    this._reminderService
      .getContactsUserLead(
        this.token,
        json,
        e !== null ? e.page : 1,
        e !== null ? e.perPage : 10,
        e !== null
          ? (this.campoBusqueda = e.search)
          : (this.campoBusqueda = ""),
        this.filtros
      )
      .subscribe(
        (response) => {
          if (response.status == "success") {
            this.paginaActual = Number(response.page_actual);
            this.itemsPorPagina = String(response.items_per_page);
            this.totalItems = Number(response.total_items_count);
            this.totalPaginas = Number(response.total_pages);

            if (newfilter) {
              this.filtros = [
                {
                  key: "filter_id",
                  title: "ID",
                  value: "",
                  type: "contains",
                  key_type: "filter_id_type",
                  type_options: [
                    { value: "nofilter", name: "No Filter" },
                    { value: "contains", name: "Contains" },
                    { value: "startswith", name: "Starts With" },
                    { value: "endswith", name: "Ends With" },
                    { value: "equalto", name: "Equal To" },
                  ],
                },
                {
                  key: "filter_rep",
                  title: "Rep",
                  value: "",
                  type: "equalto",
                  key_type: "filter_rep_type",
                  type_options: [
                    { value: "nofilter", name: "No Filter" },
                    { value: "contains", name: "Contains" },
                    { value: "startswith", name: "Starts With" },
                    { value: "endswith", name: "Ends With" },
                    { value: "equalto", name: "Equal To" },
                  ],
                },
                {
                  key: "filter_contact_date",
                  title: "Contact Date",
                  value: "",
                  type: "startswith",
                  key_type: "filter_contact_date_type",
                  type_options: [{ value: "startswith", name: "Starts With" }],
                },
                {
                  key: "filter_reminder_date",
                  title: "Reminder Date",
                  value: "",
                  type: "startswith",
                  key_type: "filter_reminder_date_type",
                  type_options: [{ value: "startswith", name: "Starts With" }],
                },
                {
                  key: "filter_description",
                  title: "Description",
                  value: "",
                  type: "contains",
                  key_type: "filter_description_type",
                  type_options: [
                    { value: "nofilter", name: "No Filter" },
                    { value: "contains", name: "Contains" },
                    { value: "startswith", name: "Starts With" },
                    { value: "endswith", name: "Ends With" },
                    { value: "equalto", name: "Equal To" },
                  ],
                },
                null,
              ];
            }

            this.contacts.rows = [];

            for (let element of response.data) {
              let actionButtons = [];

              actionButtons.push(
                { icon: "edit", action: "Edit", color: "info" },
                { icon: "delete_outline", action: "Remove", color: "danger" }
              );

              let fechaContacto = this.setDate(
                element.fechacontacto,
                element.horacontacto
              );
              let fecha = this.setDate(element.fecha, element.hora);

              this.contacts.rows.push([
                new Cell(element.id),
                new Cell(element.rep.name + " " + element.rep.surname),
                new Cell(fechaContacto),
                new Cell(
                  fecha !== "NaN-NaN-NaN"
                    ? fecha
                    : this.mtds.getFecha(
                        new Date(element.fecha.timestamp * 1000),
                        "MM-dd-yyyy"
                      )
                ),
                new Cell(element.descripcion),
                new Cell(actionButtons, { type: "actions" }),
              ]);
            }
          } else {
            /*localStorage.clear();
            this._router.navigate(["/pages/lock"]);*/
          }
          this.loading = false;
        },
        (error) => {
          console.log(<any>error);
          this.loading = false;
        }
      );
  }

  setDate(fecha, hora) {
    let fechaContacto;
    let arrayhr = hora.split(":");
    let seconds = +arrayhr[0] * 60 * 60 + +arrayhr[1] * 60;
    seconds = seconds * 1000;
    fechaContacto = fecha.timestamp * 1000;
    fechaContacto = fechaContacto + seconds;
    fechaContacto = this.mtds.getFecha(new Date(fechaContacto), "MM-dd-yyyy");
    console.log(fechaContacto);
    return fechaContacto;
  }
  convertDate(date, format) {
    let dateSplitted = date.split("-");
    let year;
    let month;
    let day;
    if (format == "mm-dd-yyyy") {
      year = dateSplitted[0];
      month = dateSplitted[1];
      day = dateSplitted[2];
      return `${month}-${day}-${year}T00:00:00`;
    } else if (format == "yyyy-mm-dd") {
      month = dateSplitted[0];
      day = dateSplitted[1];
      year = dateSplitted[2];
      return `${year}-${month}-${day}T00:00:00`;
    }
  }

  setranking(value) {
    if (this.statusLead === value) value = null;

    let enviar = {
      rank: value,
    };

    this._ContactFormService
      .setranking(this.token, this.idcontact, enviar)
      .subscribe(
        (response) => {
          if (response.status == "success") {
            this.statusLead = response.data.ranking;
            if (this.statusLead != null) {
              this.showSwal("success", "The ranking was set correctly.");
            } else {
              this.showSwal("success", "The ranking has been removed.");
            }
          } else {
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
          }
        },
        (error) => {
          console.log(<any>error);
          this.showSwal(
            "error",
            "There was a mistake, the ranking wasn't set properly."
          );
        }
      );
  }

  getFecha(fecha: Date) {
    let dia;
    dia = fecha.getDate();
    let day;
    if (dia < 10) {
      day = "0" + dia;
    } else {
      day = dia;
    }
    let mes;
    mes = fecha.getMonth() + 1;
    let month;
    if (mes < 10) {
      month = "0" + mes;
    } else {
      month = mes;
    }
    let anio = fecha.getFullYear();

    return anio + "-" + month + "-" + day;
  }

  showSwal(type, message?) {
    if (type === "success-contactHistory") {
      swal.fire({
        title: "Contact form has been saved successfully",
        text: "",
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-primary",
        },
      });
    } else {
      swal.fire({
        text: message,
        icon: type,
        buttonsStyling: false,
        timer: 3000,
        timerProgressBar: true,
        customClass: {
          confirmButton: "btn btn-primary",
        },
      });
    }
  }

  onSubmit() {
    console.log("enviamos");
    console.log(this.contacthistory);

    let json = {
      users: this.usersSeleccionados,
    };

    this._reminderService
      .create(this.token, this.contacthistory, json)
      .subscribe(
        (response) => {
          console.log(response);
          this.status_contactHistory = response.status;

          if (this.status_contactHistory != "success") {
            this.status_contactHistory = "error";
          } else {
            this.showSwal(
              "success",
              "Contact form has been saved successfully"
            );
            // this.showSwal("success-contactHistory");
            this.contacthistory = response.data;
            console.log(response.data);
            //this._router.navigate(['/task', this.task.id]);
            //this.dialogRef.close();
            this.getAllContacts();
            this.cleanContact();
            return response.data;
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
  }

  countries: any[] = [];
  states: any[] = [];
  cities: any[] = [];

  filteredStates: Observable<any[]>;
  filteredCities: Observable<any[]>;

  private _filter(value: string, options: any[]): any[] {
    const filterValue = value.toLowerCase();
    return options.filter(
      (option) =>
        (option.state && option.state.toLowerCase().includes(filterValue)) ||
        (option.city && option.city.toLowerCase().includes(filterValue))
    );
  }
  getCountries() {
    this._ContactFormService.getCountries().subscribe((data) => {
      if (data.status === "success") {
        this.countries = data.data;
      }
    });
  }
  getStates() {
    if (this.data.contact.country.id) {
      this._ContactFormService
        .getStates(this.data.contact.country.id)
        .subscribe((data) => {
          if (data.status === "success") {
            this.states = data.data;
            this.stateControl.setValue("");
          }
        });
    }
  }
  onStateSelected(event?) {
    const state = event.option.value;
    console.log("Selected State: ", state);
    this.data.contact.state.id = this.states.find((s) => s.state === state).id;
    this.getCities();
  }

  getCities() {
    if (this.data.contact.state.id) {
      this._ContactFormService
        .getCities(this.data.contact.state.id)
        .subscribe((data) => {
          if (data.status === "success") {
            this.cities = data.data;
            this.cityControl.setValue("");
          }
        });
    }
  }
  onCitySelected(event?) {
    const city = event.option.value;
    this.data.contact.city.id = this.cities.find((c) => c.city === city).id;
  }

  //Similar para estados y ciudades
  getStatesInit() {
    if (this.data.contact.country.id) {
      this._ContactFormService
        .getStates(this.data.contact.country.id)
        .subscribe((data) => {
          if (data.status === "success") {
            this.states = data.data;
            const selectedState = this.states.find(
              (s) => s.id === this.data.contact.state.id
            );
            console.log("selectedState", selectedState);
            if (selectedState) {
              this.stateControl.setValue(selectedState.state);
              //this.getCitiesInit(); // Esto cargará las ciudades
            }
          }
        });
    }
  }

  getCitiesInit() {
    if (this.data.contact.state.id) {
      this._ContactFormService
        .getCities(this.data.contact.state.id)
        .subscribe((data) => {
          if (data.status === "success") {
            this.cities = data.data;
            const selectedCity = this.cities.find(
              (c) => c.id === this.data.contact.city.id
            );
            if (selectedCity) {
              this.cityControl.setValue(selectedCity.city);
            }
          }
        });
    }
  }

  showFormContactHistory = false;
  titleFormContactHistory;

  showFormContactH(type) {
    if (type === "Edit") {
      this.showFormContactHistory = true;
    } else {
      this.showFormContactHistory = !this.showFormContactHistory;
    }
    this.titleFormContactHistory = type;
  }

  showAddPeopleToReminder = false;

  enabledEdit() {
    this.editContact = false;
    if (this.countries) {
      this.getStatesInit();
      this.getCitiesInit();
    }

    //this.leadInformationOrigin = JSON.parse(JSON.stringify(this.data.contact));
    //console.log(" this.leadInformationOrigin ",  this.leadInformationOrigin);
  }

  //leadInformationOrigin;

  cleanFormLeadInformation() {
    // set data origin
    //this.data.contact = this.leadInformationOrigin;
    this.getContactForm(this.data.contact.id);
    this.editContact = true;
    this.slideToggleState = false;
  }

  slideToggleState: boolean = false;

  onToggleChange(event?: MatSlideToggleChange) {
    if (event && event.checked) {
      console.log("El slide-toggle está en true");
      this.enabledEdit();
    } else {
      console.log("El slide-toggle está en false");
      this.cleanFormLeadInformation();
    }
  }

  getContactForm(id: number) {
    this._ContactFormService.getContact(this.token, id).subscribe(
      (response) => {
        console.log(response);
        if (response.status == "success") {
          console.log("DATA:::", response.data);
          this.data.contact = response.data;
        } else {
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }

  countFiles = 0;
  getCountFiles(data: any) {
    console.log("Información recibida del hijo:", data);
    this.countFiles = data;
  }
}
